export const actionTypes = {
  TOGGLE_COLLAPSED_NAV: 'TOGGLE_COLLAPSE_MENU',
  WINDOW_WIDTH: 'WINDOW-WIDTH'
}
